import { GET, POST } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 获取小票模块的用户信息
 */
export const fetchReceiptMemberInfo = async (params) => {
    const res = await GET(APIs.API_RECEIPT_MEMBERINFO, { params });

    return res.data ?? {};
};

/**
 * 上传小票
 */
export const fetchUploadReceipt = async (data) => {
    const res = await POST(APIs.API_RECEIPT_UPLOADRECEIPT, { data });

    return res.data ?? {};
};

/**
 * 重复小票确认后发送邮件
 */
export const fetchConfirmReceipt = async (data) => {
    const res = await POST(APIs.API_RECEIPT_CONFIRMRECEIPT, { data });

    return res.data ?? {};
};

/**
 * 扫描上传联营小票
 */
export const fetchScanReceipt = async (data) => {
    const res = await POST(APIs.API_RECEIPT_SCANRECEIPT, { data });

    return res.data ?? {};
};

/**
 * 历史小票记录
 */
export const fetchReceiptList = async (params) => {
    const res = await GET(APIs.API_RECEIPT_INDEX, { params });

    return res.data.data ?? {};
};

/**
 * 修改小票
 */
export const fetchEditReceipt = async (data) => {
    const res = await POST(APIs.API_RECEIPT_EDITRECEIPT, { data });

    return res.data ?? {};
};